import { CUSTOMER_RESOURCE_OVERVIEW_ROUTER, PROMOTION_PLAN_OVERVIEW_ROUTER, SMART_FITNESS_BAND_PROMOTION_PLAN_OVERVIEW_ROUTER } from "@Router/routerPath";
import { FRONT_KEY } from "@Constants/frontKey";
import { PromotionPlanPage } from "@Local/PromotionPlan";
import { CustomerResourcePage } from "@Local/CustomerResource";
import SmartFitnessBandPromotionPlanPage from "@Local/PromotionPlan/SmartFitnessBandPromotionPlanPage";

const documentRouter = [
	{
		description: "行銷管理",
		frontKey: FRONT_KEY.DOCUMENT,
	},
	{
		description: "行銷方案",
		frontKey: FRONT_KEY.PROMOTION_PLAN_OVERVIEW,
		static: true,
		path: PROMOTION_PLAN_OVERVIEW_ROUTER,
		href: PROMOTION_PLAN_OVERVIEW_ROUTER,
		as: PromotionPlanPage,
	},
	{
		description: "策略夥伴總覽",
        frontKey: FRONT_KEY.CUSTOMER_RESOURCE_OVERVIEW,
		strict: true,
		path: CUSTOMER_RESOURCE_OVERVIEW_ROUTER,
		href: CUSTOMER_RESOURCE_OVERVIEW_ROUTER,
		as: CustomerResourcePage,		
	},
    {
		description: "智能行銷方案",
		frontKey: FRONT_KEY.SMART_FITNESS_BAND_PROMOTION_PLAN_OVERVIEW,
		static: true,
		path: SMART_FITNESS_BAND_PROMOTION_PLAN_OVERVIEW_ROUTER,
		href: SMART_FITNESS_BAND_PROMOTION_PLAN_OVERVIEW_ROUTER,
		as: SmartFitnessBandPromotionPlanPage,
	},
];

export default documentRouter;
